/* eslint-disable react/prop-types */
import * as yup from "yup";
import { v4 as uuid } from "uuid";
import { TYPE_FIELD_LIST } from "../../../helper/TypeFieldList";
import { useMemo } from "react";
import { MESSAGE } from "../../../message";

export default function useHomeValidateSchema() {
  const loginFieldList = useMemo(
    () => [
      {
        id: uuid(),
        name: "username",
        txtLabel: MESSAGE.USERNAME,
        typeField: TYPE_FIELD_LIST.TEXTFIELD,
        type: "text",
        defaultValue: "",
        grid: [12],
        placeHolder: MESSAGE.USERNAME,
      },
      {
        id: uuid(),
        name: "password",
        txtLabel: MESSAGE.PASSWORD,
        typeField: TYPE_FIELD_LIST.TEXTFIELD,
        type: "password",
        defaultValue: "",
        grid: [12],
        placeHolder: MESSAGE.PASSWORD,
      },
      {
        id: uuid(),
        name: "forgetPassword",
        txtLabel: "Quên mật khẩu?",
        to: "",
        color: "var(--white)",
        typeField: TYPE_FIELD_LIST.LINK,
        defaultValue: "",
        grid: [12],
        placeHolder: MESSAGE.PASSWORD,
      },
    ],
    [],
  );

  const validationSchema = yup.object().shape({
    username: yup.string().required(MESSAGE.PLEASE_FILL_USERNAME),
    password: yup.string().required(MESSAGE.PLEASE_FILL_PASSWORD),
  });

  const loginObject = {
    username: undefined,
    password: undefined,
  };

  return { loginFieldList, validationSchema, loginObject };
}
